import { useParams } from "react-router-dom";
import withAuth from "../../../components/auth";
import { injectIntl } from "react-intl";

function DashboardUser(props) {   

  return (
    <>
      <user-dashboard />
    </>
  );
}

export default injectIntl(withAuth(DashboardUser));
